import { useEffect } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { movies, categories } from "@/mocks/movies";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const categoryInfo = categories.find((c) => c.slug === slug) || categories[0];
  const filteredMovies =
    slug === "all" || !slug
      ? movies
      : movies.filter((m) => m.categorySlug === slug);

  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>

      <main className="pt-20">
        <div className="px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">{categoryInfo.name}</span>
            </nav>

            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {categoryInfo.name}电影
            </h1>
            <p className="text-sm text-foreground-500 mb-8">
              共 {filteredMovies.length} 部影片
            </p>

            <div className="flex items-center gap-2 flex-wrap mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    (slug === cat.slug || (!slug && cat.slug === "all"))
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-primary-500 bg-background-100 hover:bg-background-200"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
              {filteredMovies.map((movie) => (
                <Link
                  key={movie.id}
                  to={`/article/${movie.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                    <img
                      src={movie.image}
                      alt={movie.title}
                      title={`${movie.title} - 555电影网高清在线观看`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="text-xs font-bold bg-accent-500 text-background-50 px-2 py-0.5 rounded-md whitespace-nowrap">
                        {movie.rating}
                      </span>
                    </div>
                    {movie.isNew && (
                      <div className="absolute top-2 right-2">
                        <span className="text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded-md whitespace-nowrap">
                          新
                        </span>
                      </div>
                    )}
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {movie.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {movie.year} · {movie.category}
                  </p>
                </Link>
              ))}
            </div>

            {filteredMovies.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无该分类的电影</p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}